import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bikeRack"
const BikeRackIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 19.5a3 3 0 0 1-1.35-5.68l.617 2.839a.75.75 0 1 0 1.466-.318l-.617-2.839A3 3 0 0 1 18.5 19.5Zm-6.879-4.935-2.236-4.473 5.912-.696-3.676 5.169Zm-1.761.819a4.505 4.505 0 0 0-2.161-2.811l.52-1.457 2.115 4.229-.474.039ZM5.5 19.5a3 3 0 1 1 .271-5.988l-.977 2.736a.75.75 0 0 0 .768 1l2.896-.242A3.002 3.002 0 0 1 5.5 19.5Zm1.684-5.483a3.01 3.01 0 0 1 1.149 1.494l-1.735.145.586-1.639ZM18.5 12c-.07 0-.14.001-.21.005L16.985 6H19a1 1 0 0 0 0-2h-3a1 1 0 0 0-.592 1.806l.438 2.016-7.175.844L8.338 8H9.5a1 1 0 0 0 0-2h-3a1 1 0 0 0 0 2h.162l.628 1.257-1.004 2.811a4.5 4.5 0 1 0 3.698 4.811l1.564-.13a.742.742 0 0 0 .562-.313l4.3-6.019.414 1.905A4.5 4.5 0 1 0 18.5 12Z"
      />
    </svg>
  )
}
export default BikeRackIcon
